import React, { Component } from 'react';
import SumaContexto from '../../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Row, Col, Tag, Spin, Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import ServicioDatosConstantes from '../../servicios/ServicioDatosConstantes'
import ServicioUsuarios from '../../servicios/usuarios/ServicioUsuarios'
import ServicioEntidad from '../../servicios/ServicioEntidad'
import ServicioAdministracion from '../../servicios/ServicioAdministracion'
import Constantes from '../../utilidades/Constantes'
import Utilidades from '../../utilidades/Utilidades'
import queryString from 'query-string';
import { withCookies } from 'react-cookie';


class DatosDependencia extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3
    }

    state = {
        cargando: true,
        componente: this.ENUM_COMPONENTE.CARGANDO,
        entidad: undefined,
        usuario: undefined,
    };


    constructor(props) {
        super(props);
        this.servicioDatosConstantes = new ServicioDatosConstantes(props);
        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioEntidad = new ServicioEntidad(props);
        this.servicioAdministracion = new ServicioAdministracion(props);
    }


    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {

        let params = this.props.location.search;
        let urlparametros = queryString.parse(params);
        let idDependencia = undefined;

        if (urlparametros.id !== undefined && !isNaN(parseInt(urlparametros.id))) {
            idDependencia = parseInt(urlparametros.id);
        }
        this.setSumaState({ idDependencia: idDependencia });
        
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        if (usr !== null) {
            this.setSumaState({ usuario: usr, componente: this.ENUM_COMPONENTE.VER, cargando: true });
            // Valida que tenga la accion habilitada VER
            let habilitado = await this.servicioUsuarios.accionHabilitadaPromesa(Constantes.ENUMS_MODULOS.ENTIDAD.ACCIONES.VER_ENTIDAD.id);
            if (habilitado && habilitado.resultado) {

                let respuestaApi = await this.servicioEntidad.obtenerDependenciaPromise( idDependencia );
                let dependencia = respuestaApi.resultado;
                if ( dependencia ) {
                    //console.log('dependencia', dependencia);
                    this.setSumaState({ cargando: false, usuario: usr, dependencia: dependencia });
                }
            }
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE });
        }

    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }


    render() {
        const { componente, usuario, dependencia } = this.state;

        const wrapperCol = {
            xs: { span: 21, offset: 1 },
            sm: { span: 11, offset: 1 },
        };

        const wrapperCol02 = {
            xs: { span: 22, offset: 1 },
        };

        const colLabel = { sm: { span: 7 } };
        const colTexto = { sm: { span: 17 } };

        

        return (
            <div>
                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>
                            <Spin tip="Por favor espera..." size="large" spinning={this.state.cargando}>

                                <h3 className="sub-titulo-separador margen-bottom ">Entidad</h3>
                                <div className="seccion-datos">
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Dependencia:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.dependencia : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Id dependencia:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.id : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Entidad:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia && dependencia.entidad ? dependencia.entidad.razonSocial : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Id Entidad:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia && dependencia.entidad ? dependencia.entidad.id : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Sigla:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.sigla : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Dirección dependencia:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.direccion : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Teléfono:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.telefono : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Móvil:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.celular : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Correo electrónico:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.correo : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Estado:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <Tag color={
                                                        (dependencia && dependencia.estadoDependencia.id === Constantes.ENUMS.ESTADO_DEPENDENCIA.ACTIVO.id)
                                                            ?
                                                            'green'
                                                            :
                                                            (dependencia && dependencia.estadoDependencia.id === Constantes.ENUMS.ESTADO_DEPENDENCIA.INACTIVO.id
                                                                ?
                                                                'volcano'
                                                                :

                                                                ''

                                                            )
                                                    } key={dependencia ? dependencia.estadoDependencia.estadoDependencia : ""}>
                                                        {dependencia ? dependencia.estadoDependencia.estadoDependencia.toUpperCase() : ""}
                                                    </Tag>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Fecha modificación:</label>
                                                </Col>
                                                <Col {...colTexto}>
                                                    <span>{dependencia ? dependencia.fechaModificoFormato : ''}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <br/>
                                    <Row className="fila">
                                        <Col  {...wrapperCol}>
                                            <Row>
                                                <Col {...colLabel}>
                                                    <label className="titulo-etiqueta">Descripción:</label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="row_col_span_texto">
                                        <Col {...wrapperCol02}>
                                            {dependencia ? Utilidades.saltoDeLinea(dependencia.descripcion) : ''}
                                        </Col>
                                    </Row>
                                    <br/>
                                </div>

                                <h3 className="sub-titulo-separador margen-bottom margen-top">Opciones</h3>
                                <div className="seccion-datos seccion-final">
                                    {(dependencia)
                                        ?
                                        (<>
                                            {Utilidades.accionPermitida(usuario, Constantes.ENUMS_MODULOS.DEPENDENCIA.ACCIONES.ACTUALIZAR_INFORMACION_DEPENDENCIA.id) ?
                                                <Button className="boton-opcion"
                                                    icon={<EditOutlined style={{ color: '#c90a00' }} />}
                                                    onClick={(e) => { this.props.callbackEditarDependencia(e, this.state.idDependencia) }}>
                                                    Editar
                                                </Button>
                                            :<></>}
                                        </>)
                                        :
                                        (<></>)
                                    }
                                </div>

                                {/*<h3 className="sub-titulo-separador margen-bottom margen-top">Dependencias</h3>
                                <div className="seccion-datos seccion-final">
                                    <Table  columns={columns}
                                            dataSource={ entidad && entidad.dependencias ? entidad.dependencias : []  }
                                            rowKey={"id"} 
                                            size="small"/>
                                </div>*/}

                            </Spin>

                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:DATDEP]</label>) : (<></>))
                    )
                }
            </div>
        );
    }
}

export default withRouter(withCookies(DatosDependencia));